import { ValidatorFn } from '@angular/forms';

export const emailValidator: ValidatorFn = ({ value }) => {
  const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
  return !value || emailRegex.test(value) ? null : { email: true };
};
